import axios, { AxiosInstance } from 'axios';
const api: AxiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: 3 * 60 * 1000,
    headers: {
        'Content-Type': 'application/json',
    },
});


export default api;